module.exports = __webpack_public_path__ + "img/index1.b717daf6.png";